var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLadderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_3057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58738 10.7705L6.16759 13.1414L8.8827 13.9253L6.54763 15.5111L5.78752 18.2537L4.20731 15.8828L1.49219 15.099L3.82726 13.5131L4.58738 10.7705Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6803 11.0566H21.3192C21.967 11.0566 22.4922 10.534 22.4922 9.88939C22.4922 9.24474 21.967 8.72215 21.3192 8.72215H16.9765C16.0696 8.72215 15.3344 9.45378 15.3344 10.3563V14.3249H12.5348C11.6279 14.3249 10.8926 15.0565 10.8926 15.959V19.9277H7.24346C6.59564 19.9277 6.07048 20.4503 6.07048 21.0949C6.07048 21.7396 6.59564 22.2621 7.24346 22.2621H11.5964C12.5034 22.2621 13.2386 21.5305 13.2386 20.628V16.6594H16.0381C16.9451 16.6594 17.6803 15.9278 17.6803 15.0253V11.0566Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4238 0.262146L15.9205 2.47998L18.4922 3.21319L16.2805 4.69664L15.5606 7.26215L14.0638 5.04432L11.4922 4.31111L13.7039 2.82765L14.4238 0.262146Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_3057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.492188 0.262146)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadderIcon);
export default __webpack_public_path__ + "static/media/ladder-icon.3467089924b569ead75c3551bd56e6ce.svg";
export { ForwardRef as ReactComponent };